import Immutable from "seamless-immutable";
import {
  HIDE_LOADING,
  SHOW_ERROR,
  SHOW_LOADING,
  UPDATE_BADGE,
  GET_EMAIL_PREFERENCES_RESPONSES,
  CREATE_EMAIL_PREFERENCES,
  UPDATE_EMAIL_PREFERENCES
} from "./Types";
import api from "../../api";
import { addItem, replaceOrAddItems } from "../../transforms/ItemTransforms";

export function getEmailPreferencesResponses() {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      let result = await api.emailPreferences.getEmailPreferences();
      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
      } else {
        dispatch({ type: GET_EMAIL_PREFERENCES_RESPONSES, data: result.data });
      }
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function handleSaveEmailPreferences(data) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      const result = await api.emailPreferences.creatEmailPreference(data);
      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }
      let { items } = getState().emailsPrefs;
      items = Immutable.asMutable(items);

      items = addItem(items, result.data);

      dispatch({ type: CREATE_EMAIL_PREFERENCES, items });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function handleUpdateEmailPreferences(data) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      let { items } = getState().emailsPrefs;
      const result = await api.emailPreferences.updateEmailPreferences(data);
      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }

      items = replaceOrAddItems(items, result.data);

      dispatch({ type: UPDATE_EMAIL_PREFERENCES, items });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function handleDeleteEmailPreferences(id) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      let { items } = getState().emailsPrefs;
      items = Immutable.asMutable(items);

      let itemIdx = items.findIndex(item => item.id === id);
      if (itemIdx === -1) {
        dispatch({ type: SHOW_ERROR, message: "Could not find email." });
        return;
      }

      const result = await api.emailPreferences.deleteEmailPreferences(id);

      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }

      items = Immutable.asMutable(items);
      items.splice(itemIdx, 1);

      dispatch({ type: UPDATE_EMAIL_PREFERENCES, items });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}